import type { App } from 'vue'

import { abilitiesPlugin } from '@casl/vue'
import { ability } from './ability'

export default function (app: App) {
  // ใช้ ability instance เดียวกันกับที่ export จาก ability.ts
  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
}
